import routes from './routes_by_role';

const validateRoutesByRole = (roles: any) => {
  const routesToReturn: any[] = [];
  if (typeof roles === 'undefined' || !roles) {
    return [];
  }

  if (Array.isArray(roles)) {
    roles.forEach((item) => {
      const rol = item.toLowerCase();
      if (routes[rol]) {
        const arrayRoutes = routes[rol];
        arrayRoutes.forEach((item: any) => {
          if (routesToReturn.indexOf(item) < 0) {
            routesToReturn.push(item);
          }
        });
      }
    });
  } else {
    const rol = roles.toLowerCase();
    if (routes[rol]) {
      const arrayRoutes = routes[rol];
      arrayRoutes.forEach((item: any) => {
        if (routesToReturn.indexOf(item) < 0) {
          routesToReturn.push(item);
        }
      });
    }
  }

  return routesToReturn;
};

export default validateRoutesByRole;
